import { URLs } from "../url";
import { fetchRequest } from "../fetchRequest";
import { CatalogueResponse } from "../../model/catalogue";
import { getHeader } from "../headers";

const getGeneralCatalogue = async (
  clientId: string,
  type: string,
  enable: boolean,
  page: number,
  limit: number,
) => {
  let newURL =
    process.env.REACT_APP_HOST_API +
    URLs.catalog +
    `?clientId=${clientId}` +
    `&type=${type}` +
    `&enable=${enable}&page=${page}&limit=${limit}`;
  
  const requestOptions = {
    method: "GET",
    headers: getHeader(),
  };
  try {
    const response = await fetchRequest(newURL, requestOptions) as CatalogueResponse;
    return response;
  } catch (error: any) {
    throw error;
  }
};

export { getGeneralCatalogue };
